import { ActionDoneType } from "@/enums/ActionDoneType.enum";
import { AlertService } from "@/services/alert.service";
import { AppConfigService } from "@/services/app-config.service";
import { NgTemplateOutlet } from "@angular/common";
import { Component, Inject, OnDestroy } from "@angular/core";
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  Validators,
} from "@angular/forms";
import { MatOptionModule } from "@angular/material/core";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { PropertiesService, RealProperty } from "@eemo/api-client";
import { Subscription } from "rxjs";
import { environment } from "src/environments/environment";
import { ModalBaseComponent } from "../base/modal-base/modal-base.component";
import { InputComponent } from "../ui-forms/input/input.component";

export class PropertyDpeUpdateDialogData {
  prop: RealProperty;
}

@Component({
  selector: "app-property-dpe-update-dialog",
  templateUrl: "./property-dpe-update-dialog.component.html",
  styleUrls: ["./property-dpe-update-dialog.component.scss"],
  standalone: true,
  imports: [
    ModalBaseComponent,
    NgTemplateOutlet,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    InputComponent,
  ],
})
export class PropertyDpeUpdateDialogComponent implements OnDestroy {
  dialogTitle: string;
  loading = false;

  subAttr = new Subscription();
  subSync = new Subscription();

  get form_dpeNumber() {
    return this.form.get("dpeNumber") as FormControl<string>;
  }

  form = this.fb.group({
    dpeNumber: [null, Validators.required],
  });
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PropertyDpeUpdateDialogData,
    private fb: UntypedFormBuilder,
    private propertiesService: PropertiesService,
    private alertService: AlertService,
    private appConfigService: AppConfigService,
    public dialogRef: MatDialogRef<PropertyDpeUpdateDialogComponent>
  ) {
    this.dialogTitle = "Saisie du numéro DPE";
  }

  ngOnDestroy(): void {
    this.subAttr.unsubscribe();
    this.subSync.unsubscribe();
  }

  onSubmit() {
    if (this.form.valid) {
      this.loading = true;

      this.subAttr = this.propertiesService
        .updateRealPropertyAttributes(this.data.prop.uid, [
          {
            code: environment.DPE_ATTRIBUTE_NUMBER,
            value: this.form_dpeNumber.value,
          },
        ])
        .subscribe({
          next: () => {
            this.subSync = this.propertiesService
              .syncRealPropertyOpenData(this.data.prop.uid)
              .subscribe({
                next: () => {
                  this.loading = false;
                  this.alertService.success(
                    `Récupération du DPE ${this.form_dpeNumber.value} en cours`
                  );
                  this.appConfigService.triggerActionDone(
                    ActionDoneType.OPENDATA_SYNC
                  );
                  this.dialogRef.close(true);
                },
                error: () => {
                  this.loading = false;
                },
              });
          },
          error: () => {
            this.loading = false;
          },
        });
    }
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
